export function createPropertyDescriptorMap(propertyInit) {
    if (!propertyInit) {
        return {};
    }
    return Object.keys(propertyInit)
        .filter((key) => {
        if (typeof key === 'string') {
            return true;
        }
        else {
            throw new Error(`Property init cannot have non string keys: "${key}"`);
        }
    })
        .reduce((accum, currentKey) => {
        accum[currentKey] = {
            propName: currentKey,
            initValue: propertyInit[currentKey],
        };
        return accum;
    }, {});
}
